/**
 * レビューの操作が失敗した理由を、人が読む形にする。
 *
 * **API が返したメッセージはそのまま見せる。** 権限・状態の前後関係・本文の上限は product-api
 * と domain が持っており、入口で訳し直すと API 側で文言が変わったときに黙ってずれる。
 * 画面で足すのは、本文を持たない 403（認可で落ちたことしか分からない）と、
 * メッセージが取れなかったときの受け皿だけ。
 *
 * 操作の節（`ReviewActions`）と返信の欄（`ReviewReply`）の両方が使う。節ごとに書き分けると、
 * 同じ 403 が片方では「権限がありません」、もう片方では生のエラーで出る。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 要件定義のレビュー操作が失敗した理由を、API のメッセージを保ったまま画面に出す
 * @graph-connects ApiError [references] 操作が失敗した理由の判別
 */

import type { TFunction } from 'i18next';
import { ApiError } from '../../../lib/api/_request.js';

/**
 * 失敗の理由。
 * @graph-connects ApiError [references] 操作が失敗した理由の判別
 */
export function reviewErrorMessage(t: TFunction, error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 403) return t('spec.review.error.forbidden');
    return error.message;
  }
  if (error instanceof Error) return error.message;
  return t('spec.review.error.failed');
}
